// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__344HA","name":"ConsentHeader_name__16H8t","birthday":"ConsentHeader_birthday__125T_","skeleton":"ConsentHeader_skeleton__2a8Y7"};